import React, {useContext} from "react";
import Img from "../../common/Img";
import MainButton from "../../common/MainButton";
import lbl from "../../../data/Labels.json";
import MainTitle from "../../common/MainTitle";
import {PopUpContext} from "../../../contexts/popUpContext";

const PersonalInfo = ({student, studentInfo, callback}) => {
    const {togglePopUp} = useContext(PopUpContext);

    return (
        <div className="student-info">
            <div className="main-content-header">
                <div className="left-content">
                    <MainButton
                        type={studentInfo ? "pen" : "add"}
                        title={lbl.Edit}
                        handleClick={() => togglePopUp({
                            form: "student-personal-info-form",
                            edit: studentInfo,
                            student: student,
                            callback: callback,
                        })}
                    />
                </div>

                <div className={"right-content"}>
                    <MainTitle title="معلومات شخصی"/>
                </div>
            </div>
            <div className="student-detail">
                <div className="detail_item">
                    <p>نام پدرکلان</p>
                    <p>{studentInfo?.grand_father_name}</p>
                </div>
                {/*<div className="detail_item">*/}
                {/*    <p>ایمیل</p>*/}
                {/*    <p>{student.student_email}</p>*/}
                {/*</div>*/}
                <div className="detail_item">
                    <p>نام مادر</p>
                    <p>{studentInfo?.mother_name}</p>
                </div>
                {/*<div className="detail_item">*/}
                {/*    <p>جنسیت</p>*/}
                {/*    <p>{student.gender_name}</p>*/}
                {/*</div>*/}
                <div className="detail_item">
                    <p>شماره تذکره</p>
                    <p>{studentInfo?.tazkera_no}</p>
                </div>
                <div className="detail_item">
                    <p>سکونت فعلی</p>
                    <p>{studentInfo?.current_address_city_name}</p>
                </div>
                <div className="detail_item">
                    <p>آدرس سکونت فعلی</p>
                    <p>{studentInfo?.current_address}</p>
                </div>
                <div className="detail_item">
                    <p>سکونت اصلی</p>
                    <p>{studentInfo?.permanent_address_city_name}</p>
                </div>
                <div className="detail_item">
                    <p>آدرس سکونت اصلی</p>
                    <p>{studentInfo?.permanent_address}</p>
                </div>
                <div className="detail_item">
                    <p>حمایت کننده مالی</p>
                    <p>{studentInfo?.supporter_name}</p>
                </div>
                <div className="detail_item">
                    <p>شماره تماس پدر/مادر</p>
                    <p>{studentInfo?.parent_phone}</p>
                </div>
                <div className="detail_item">
                    <p>وظیفه پدر/مادر</p>
                    <p>{studentInfo?.parent_job}</p>
                </div>
            </div>
        </div>
    );
};

export default PersonalInfo;
